import { styled } from '@mui/material'

export const ItemHeader = styled('div')({
  fontSize: '12px',
  fontWeight: 500,
  letterSpacing: '0.15px',
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  alignItems: 'center',
});

export const ItemContent = styled('div')({
  lineHeight: '20px',
  fontSize: '14px',
  fontWeight: 400,
  marginTop: '6px'
});